import { useApiClient } from "../apiClients";
import { ENDPOINTS_PAIEMENT } from "./endpoints";

export type TPricing = {
  id_pricing: number;
  codepays: string;
  prix: number;
  devise: string;
  // Combien vaut 1 unité de `devise` dans la devise de la boutique du
  // prestataire international (Lemon Squeezy). 1 pour un pays déjà tarifé dans
  // cette devise ; absent = aucune conversion possible.
  taux_conversion?: number;
  created_at: string;
  updated_at: string;
};

// taux_conversion est facultatif : omis, le taux existant est conservé ;
// envoyé à 0, il est effacé.
export type TPricingUpsert = {
  codepays: string;
  prix: number;
  devise: string;
  taux_conversion?: number;
};

export const usePricingApi = () => {
  const client = useApiClient("paiement");
  return {
    list: async (): Promise<TPricing[]> => {
      const { data } = await client.get<{ items: TPricing[] }>(ENDPOINTS_PAIEMENT.PRICING.LIST);
      return data.items;
    },
    upsert: async (payload: TPricingUpsert) => {
      return client.post(ENDPOINTS_PAIEMENT.PRICING.UPSERT, payload);
    },
    remove: async (id: number) => {
      return client.delete(ENDPOINTS_PAIEMENT.PRICING.DELETE(id));
    },
  };
};
